import { type FC } from "react";
import { useNavigate } from "react-router";

import { faArrowLeft } from "@fortawesome/pro-duotone-svg-icons/faArrowLeft";
import { faHome } from "@fortawesome/pro-duotone-svg-icons/faHome";
import { faMagnifyingGlass } from "@fortawesome/pro-duotone-svg-icons/faMagnifyingGlass";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button } from "@styled/button";
import { ButtonLink } from "@styled/button_link";
import { CenteredPage } from "@styled/centered_page";
import { Panel } from "@styled/panel";
import { PanelControls } from "@styled/panel_controls";
import { PanelSection } from "@styled/panel_section";
import { PanelSubtitle } from "@styled/panel_subtitle";
import { PanelTitle } from "@styled/panel_title";

export const NotFound: FC = () => {
  const navigate = useNavigate();

  return (
    <CenteredPage>
      <Panel>
        <PanelSection>
          <FontAwesomeIcon icon={faMagnifyingGlass} size="2x" />
        </PanelSection>

        <PanelSection>
          <PanelTitle>We couldn&apos;t find that</PanelTitle>
          <PanelSubtitle>
            It may have been deleted, or it may belong to a different
            organization than the one you&apos;re in.
          </PanelSubtitle>
        </PanelSection>

        <PanelSection>
          <PanelControls>
            <Button color="white" onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} />
              Go back
            </Button>

            <ButtonLink to="/dashboard" color="indigo">
              <FontAwesomeIcon icon={faHome} />
              Dashboard
            </ButtonLink>
          </PanelControls>
        </PanelSection>
      </Panel>
    </CenteredPage>
  );
};
